import { onboardingStepTextFactory } from 'src/app/core/utils';
import { OnboardingTour } from 'src/app/core/services/api/onboarding.service';
import { OnboardingTourName } from 'src/app/core/enums';

const otKey = onboardingStepTextFactory('releaseCertificate');
export const releaseCertificateOnboardingTour: OnboardingTour = {
  name: OnboardingTourName.ReleaseCertificate,
  steps: [
    {
      title: otKey('token').title,
      content: otKey('token').content,
      attachTo: '#qr-section',
    },
    {
      title: otKey('email').title,
      content: otKey('email').content,
      attachTo: '#email-input',
    },
    {
      title: otKey('advanced').title,
      content: otKey('advanced').content,
      attachTo: '#advanced-section',
    },
    {
      title: otKey('summary').title,
      content: otKey('summary').content,
      attachTo: '#summary-section',
    },
  ],
};

export const releaseMultipleCertificatesOnboardingTour: OnboardingTour = {
  name: OnboardingTourName.ReleaseCertificate,
  steps: [
    {
      title: otKey('email').title,
      content: otKey('email').content,
      attachTo: '#email-input',
    },
    {
      title: otKey('advanced').title,
      content: otKey('advanced').content,
      attachTo: '#advanced-section',
    },
    {
      title: otKey('summary').title,
      content: otKey('summary').content,
      attachTo: '#summary-section',
    },
  ],
};
